<template>
  <div class="container">
    <transition name="slide-fade">
      <div class="query-protocols" v-show="isShow">
        <div class="query-protocols-header">
          <img class="logo fl" src="../assets/images/logo_dark.png" alt="" @click="handleBackIndex">
          <Icon type="close-round" class="close fr" @click.native="isShow=false" size="30"></Icon>
        </div>
        <div class="query-protocols-body clearfix">
          <div class="fl main-left">
            <h2 class="title">查询须知</h2>
            <div class="content-container">
              <div class="content-wrapper">
                <div class="content">
                  <p class="mb30">1. “滴滴清风”违规失信人员及合作伙伴查询功能提供的数据，包含部分因严重违反我司管理规定而被解除劳动合同的正式员工，部分因严重违反我司《合作伙伴阳光诚信暨反商业贿赂协议书》而永久停止合作的供应商。</p>
                  <p class="mb30">2. 使用【违规人员查询】功能时，姓名与身份证号码需完全匹配，如姓名、身份证号有误或所查人员不在违规人员通报名单中，系统都会显示“您所查询的人员不在违规名单中，或者输入的姓名和身份证号有误或不匹配。”</p>
                  <p class="mb30">3. 使用【违规合作伙伴】查询功能时，企业完整名称与企业统一信用代码需完全匹配，如企业完整名称、企业统一信用代码有误或所查合作伙伴不在违规合作伙伴通报名单中，系统都会显示“您所查询的企业不在违规名单中，或者输入的企业名称和统一社会信用代码有误或不匹配。”</p>
                  <p class="mb30">4. 如您希望了解违规人员或违规合作伙伴的违规事实，如需了解违规事实，与滴滴出行人力资源部联系：010-83043000。</p>
                  <p class="mb30">5. 查询功能使用者所查询到的任何信息不得截图、复制、屏幕拍照等方式发布在任何公开平台上，不得向任何第三方透露查询到的内容。</p>
                </div>
              </div>
              <!-- <div id="track">
                <span id="scrollBar"></span>
              </div> -->
            </div>
          </div>
          <div class="middle-line fl"></div>
          <div class="fl main-right fr">
            <h2 class="title">用户认证</h2>
            <div class="form">
              <Form ref="form" :model="form" :rules="ruleValidate">
                <FormItem prop="phone" class="phone">
                  <div class="placeholder placeholder-auth" ref="phonePlacehoder" @click="handleClick('phone',$event)">请输入手机号</div>
                  <Input v-model.trim="form.phone" size="large" ref="phone" @on-blur="handleBlur('phonePlacehoder')" @on-focus="handleFocus('phonePlacehoder')" :maxlength="11"></Input>
                </FormItem>
                <FormItem prop="imgCode" class="img-auth">
                  <div class="placeholder placeholder-auth" ref="imgCodePlacehoder" @click="handleClick('imgCodeinput',$event)">请输入验证码</div>
                  <Input v-model.trim="form.imgCode" size="large" ref="imgCodeinput" :maxlength="4" @on-blur="handleBlur('imgCodePlacehoder')" @on-focus="handleFocus('imgCodePlacehoder')"></Input>
                  <img :src="codeUrl" alt="" class="imgCode">
                  <img @click="handleRefreshCode" class="btn-refresh" src="../assets/images/btn-refresh.svg" alt="">
                  <p class="error-tips" v-if="errorMsg">{{errorMsg}}</p>
                </FormItem>
                <FormItem prop="smsCode" class="auth-code">
                  <div class="placeholder placeholder-auth" ref="smsCodePlacehoder" @click="handleClick('smsCodeinput',$event)">请输入动态验证码</div>
                  <Input v-model.trim="form.smsCode" size="large" ref="smsCodeinput" :maxlength="6" @on-blur="handleBlur('smsCodePlacehoder')" @on-focus="handleFocus('smsCodePlacehoder')"></Input>
                  <button type="button" class="btn-get" v-if="!isDisabled" @click="handleGetAuth">获取动态验证码</button>
                  <button type="button" class="btn-get" v-else>{{seconds}}s后重新获取</button>
                  <p class="error-tips" v-if="smsErrorMsg">{{smsErrorMsg}}</p>
                </FormItem>
                <FormItem prop="agree" class="checkbox">
                  <Checkbox v-model="form.agree">
                    <span class="agree">同意</span>
                  </Checkbox>
                  <span class="query">
                    <<查询须知>></span>
                </FormItem>
                <FormItem>
                  <a href="javascript:;" class="btn btn-auth" @click="handleAuth('form')">认证</a>
                </FormItem>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <div class="query">
      <Header :isLight="isLight" :isMenuLight="isMenuLight" class="static-header"></Header>
      <div class="query-wapper">
        <h2 class="query-title">违约查询</h2>
        <div class="form-query">
          <Form ref="formSearch" :model="formSearch" :rules="ruleValidate">
            <FormItem>
              <div class="form-group clearfix">
                <div class="select-wrapper fl" v-clickoutside="handleClose">
                  <FormItem prop="typeName">
                    <!-- <div class="mask"></div> -->
                    <Input v-model="formSearch.typeName" @click.native="isDropDown=!isDropDown" placeholder="请选择" disabled readonly></Input>
                  </FormItem>
                  <Icon type="chevron-down" v-show="!isDropDown" style="cursor: pointer;" @click.native="isDropDown=true"></Icon>
                  <Icon type="chevron-up" v-show="isDropDown" style="cursor: pointer;" @click.native="isDropDown=false"></Icon>
                  <div class="query-type-list-wrapper" v-show="isDropDown">
                    <ul class="query-type-list">
                      <li v-for="(item,index) in list" :key="item.id" class="item" :class="{sleceted:item.sleceted}" @click="handleChoose(index)">{{item.name}}</li>
                    </ul>
                  </div>
                </div>
                <div class="bar fl"></div>
                <FormItem prop="name" v-if="formSearch.type==1" key="personName" class="fl">
                  <div class="placeholder" ref="namePlacehoder" @click="handleClick('inputName',$event)">请填写违规人员姓名</div>
                  <Input class="name" v-model.trim="formSearch.name" ref="inputName" :maxlength="50" @on-blur="handleBlur('namePlacehoder')" @on-focus="handleFocus('namePlacehoder')"></Input>
                </FormItem>
                <FormItem prop="companyName" v-else key="companyName" class="fl">
                  <div class="placeholder" ref="companyNamePlacehoder" @click="handleClick('inputName',$event)">请填写违规企业名称</div>
                  <Input class="name" ref="inputName" @on-blur="handleBlur('companyNamePlacehoder')" @on-focus="handleFocus('companyNamePlacehoder')" v-model.trim="formSearch.companyName" :maxlength="50"></Input>
                </FormItem>
                <div class="bar fl"></div>
                <FormItem prop="idCard" v-if="formSearch.type==1" key="personId" class="fl">
                  <div class="placeholder" ref="idPlacehoder" @click="handleClick('inputId',$event)">请填写18位身份证号码</div>
                  <Input class="idcard" ref="inputId" @on-blur="handleBlur('idPlacehoder')" @on-focus="handleFocus('idPlacehoder')" v-model.trim="formSearch.idCard" :maxlength="18"></Input>
                </FormItem>
                <FormItem prop="companyIdCard" v-else key="companyId" class="fl">
                  <div class="placeholder" ref="companysIdCard" @click="handleClick('inputId',$event)">请填写统一社会信用代码</div>
                  <Input class="idcard" ref="inputId" @on-blur="handleBlur('companysIdCard')" @on-focus="handleFocus('companysIdCard')" v-model.trim="formSearch.companyIdCard" :maxlength="18"></Input>
                </FormItem>
                <img class="btn-search" @click="handleSearch('formSearch')" src="../assets/images/search.svg" alt="">
              </div>
              <p class="query-tips" v-if="formSearch.type==1">
                <Icon type="information-circled"></Icon>查询范围仅限于因严重违反我司管理规定而被解除劳动合同的正式员工。</p>
              <p class="query-tips" v-else>
                <Icon type="information-circled"></Icon>查询范围仅限于因严重违反我司《合作伙伴阳光诚信暨反商业贿赂协议书》而永久停止合作的供应商。</p>
              <div class="success-tips search-tips" v-if="success">
                <div class="f-line" v-if="formSearch.type==1">
                  <p><img class="icon-tips fl" src="../assets/images/success.svg" alt="">
                    <span>您查询的人员因严重违反我司管理规定而被解除劳动合同的正式员工，</span>
                  </p>
                  <p>
                    <span>如需了解违规事实，与滴滴出行人力资源部联系：010-83043000</span>
                  </p>
                </div>
                <div class="f-line" v-else>
                  <p><img class="icon-tips fl" style="margin-right:10px;" src="../assets/images/success.svg" alt="">
                    <span>您查询的企业因严重违反我司《合作伙伴阳光诚信暨反商业贿赂协议书》</span>
                  </p>
                  <p>
                    <span>而永久停止合作。</span>
                  </p>
                </div>
              </div>
              <div class="failure-tips search-tips clearfix" v-if="failure">
                <p class="f-line" v-if="formSearch.type==1"><img class="icon-tips fl" src="../assets/images/failure.svg" alt="">您所查询的人员不在违规名单中，或者输入的姓名和身份证号有误或不匹配。</p>
                <p class="f-line" v-else><img class="icon-tips fl" src="../assets/images/failure.svg" alt="">您所查询的企业不在违规名单中，或者输入的企业名称和统一社会信用代码有误或不匹配。</p>
              </div>
            </FormItem>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dataStatistics from '@/assets/js/dataStatistics'
import { authCodeMixin } from '@/mixins/authCodeMixin'
import { backIndexMixin } from '@/mixins/backIndexMixin'
import clickoutside from '@/directives/clickoutside'
import Header from '@/components/Header'
import api from '@/api/api'
export default {
  name: 'discreditInquiry',
  mixins: [authCodeMixin, backIndexMixin],
  directives: { clickoutside },
  components: {
    Header
  },
  data() {
    const validateAgree = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请勾选查询须知'));
      } else {
        callback();
      }
    };
    const validatePhone = (rule, value, callback) => {
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (value === '') {
        callback(new Error('请输入手机号'));
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的手机号码'));
        callback();
      } else {
        callback();
      }
    };
    const validateId = (rule, value, callback) => {
      const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
      if (value === '') {
        callback(new Error('请填写18位身份证号码'));
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的身份证号'));
      } else {
        callback();
      }
    };
    const validateCompanyId = (rule, value, callback) => {
      const reg = /^[0-9A-Za-z]+$/;
      if (value === '') {
        callback(new Error('请填写统一社会信用代码'));
      } else if (value.length !== 18 || !reg.test(value)) {
        callback(new Error('请填写正确的统一社会信用代码'));
      } else {
        callback();
      }
    };
    return {
      success: false,
      failure: false,
      isShow: false,
      isLight: false,
      isMenuLight: false,
      isDisabled: false,
      errorMsg: '',
      smsErrorMsg: '',
      seconds: 60,
      form: {
        phone: '',
        smsCode: '',
        imgCode: '',
        agree: false
      },
      formSearch: {
        type: 1,
        name: '',
        idCard: '',
        typeName: '人员查询',
        companyName: '',
        companyIdCard: ''
      },
      indexUrl: '',
      typeName: '',
      isDropDown: false,
      ruleValidate: {
        typeName: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        name: [
          { required: true, message: '请填写违规人员姓名', trigger: 'blur' }
        ],
        companyName: [
          { required: true, message: '请填写违规企业名称', trigger: 'blur' }
        ],
        agree: [
          { validator: validateAgree, trigger: 'change' }
        ],
        phone: [
          { validator: validatePhone, trigger: 'blur' }
        ],
        idCard: [
          { validator: validateId, trigger: 'blur' }
        ],
        companyIdCard: [
          { validator: validateCompanyId, trigger: 'blur' }
        ],
        imgCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        smsCode: [
          { required: true, message: '请输入动态验证码', trigger: 'blur' }
        ],
      },
      list: [
        {
          id: 1,
          name: '人员查询',
          sleceted: true
        },
        {
          id: 2,
          name: '企业查询',
          sleceted: false
        },
      ],
      timeInterval: null
    }
  },
  created() {
    dataStatistics('PC-违约查询页', '进入', '违约查询')
  },
  methods: {
    handleClick(name, e) {
      e.target.style.display = 'none'
      this.$refs[name].focus()
    },
    handleBlur(name) {
      console.log(name);
      if (name === 'namePlacehoder' && this.formSearch.name == '') {
        this.$refs[name].style.display = 'block'
      }
	  if (name === 'companyNamePlacehoder' && this.formSearch.companyName == '') {
        this.$refs[name].style.display = 'block'
      }
      if (name === 'idPlacehoder' && this.formSearch.idCard == '') {
        this.$refs[name].style.display = 'block'
      }
	  if (name === 'companysIdCard' && this.formSearch.companyIdCard == '') {
        this.$refs[name].style.display = 'block'
      }

      if (name === 'phonePlacehoder'&&this.form.phone == '') {
        this.$refs[name].style.display = 'block'
      } 

      if (name === 'imgCodePlacehoder'&&this.form.smsCode == '') {
        this.$refs[name].style.display = 'block'
      }

      if (name === 'smsCodePlacehoder'&&this.form.imgCode == '') {
        this.$refs[name].style.display = 'block'
      }
    },
    handleFocus(name) {
      this.$refs[name].style.display = 'none'
    },
    handleClose() {
      this.isDropDown = false
    },
    // 切换查询类型
    handleChoose(index) {
      this.list.forEach((item, i) => {
        if (index === i) {
          this.$set(this.list[i], 'sleceted', true)
        } else {
          this.$set(this.list[i], 'sleceted', false)
        }
      })
      const form = this.formSearch
      form.typeName = this.list[index].name
      form.type = this.list[index].id
      this.isDropDown = false
      form.idCard = ''
      form.name = ''
      form.companyName = ''
      form.companyIdCard = ''
      this.success = false
      this.failure = false

    },
    handleTimeInterval() {
      this.timeInterval = setInterval(() => {
        this.seconds--
        if (this.seconds <= 0) {
          clearInterval(this.timeInterval)
          this.isDisabled = false
          this.seconds = 60
        }
      }, 1000);
    },
    // 查询之前校验
    handleSearch(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.isShow = true
          this.success = false
          this.failure = false
        }
      })
    },
    // 认证成功之后查询
    handleAuth(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.formSearch.type === 1) {
            this.getInfo('person')
          } else {
            this.getInfo('company')
          }
        }
      })
    },
    // 获取短信验证码
    handleGetAuth() {
      this.$refs.form.validateField('imgCode');
      this.$refs.form.validateField('phone');
      this.$nextTick(() => {
        if (document.querySelector('.phone .ivu-form-item-error-tip') || document.querySelector('.img-auth .ivu-form-item-error-tip')) {
          return
        }
        this.smsCodeTime = Date.parse(new Date())
        const formData = this.$qs.stringify({
          phone: this.form.phone,
          timeStamp: this.smsCodeTime,
          imgCode: this.form.imgCode,
          imgTimeStamp: this.imgCodeTime
        })

        this.getSms(formData)
        this.isDisabled = true

        this.handleTimeInterval()
      })
    },
    // 查询
    getInfo(type) {
      const formSearch = this.formSearch
      const formData = this.$qs.stringify({
        name: type === 'person' ? formSearch.name : formSearch.companyName,
        idCard: type === 'person' ? formSearch.idCard : formSearch.companyIdCard,
        phone: this.form.phone,
        smsCode: this.form.smsCode,
        smsTimeStamp: this.smsCodeTime,
        imgCode: this.form.imgCode,
        imgTimeStamp: this.imgCodeTime
      })
      api.illegalInfo[type](formData).then(res => {
        if (res.data.code === 200) {

          if (res.data.data) {
            this.success = true
          } else {
            this.failure = true
          }
          this.isShow = false
          this.errorMsg = ''
          this.smsErrorMsg = ''
          this.form.agree = false
          this.$refs['form'].resetFields();
          this.seconds = 60
          this.isDisabled = false
          clearInterval(this.timeInterval)
          this.handleRefreshCode()
        } else if (res.data.code === 300) {
          this.smsErrorMsg = ''
          this.errorMsg = '图片验证码已过期!'
          this.handleRefreshCode()
          this.seconds = 60
          this.isDisabled = false
          clearInterval(this.timeInterval)
        } else if (res.data.code === 301) {
          this.smsErrorMsg = ''
          this.errorMsg = '图片验证码错误！'
          this.handleRefreshCode()
          this.seconds = 60
          this.isDisabled = false
          clearInterval(this.timeInterval)
        } else if (res.data.code === 302) {
          this.errorMsg = ''
          this.smsErrorMsg = '短信验证码超过最大发送次数！'
        } else if (res.data.code === 303) {
          this.errorMsg = ''
          this.smsErrorMsg = '短信验证码过期！'
        } else if (res.data.code === 304) {
          this.errorMsg = ''
          this.smsErrorMsg = '请输入正确的动态码！'
        }
      })
    },
  },
  beforeDestroy() {
    clearInterval(this.timeInterval)
  }
}
</script>
<style lang="less" scoped>
.container {
  height: 100%;
}
.query {
  height: 100%;
}
.query-protocols-body {
  width: 80%;
  margin: 0 auto;
  margin-top: 50px;
}
.query-protocols {
  // position: absolute;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  z-index: 2018;
  background-color: #f5f5f5;
  overflow: auto;
}
.form {
  width: 90%;
  margin: 0 auto;
  /deep/ .ivu-form-item {
    margin-bottom: 30px;
    .ivu-input {
      border-radius: 23px;
      border: 1px solid #313131;
      padding-left: 20px;

      &:focus {
        box-shadow: 0 0 0 0;
      }
    }
  }
  .auth-code {
    .btn-get {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      -ms-transform: translateY(-50%);
      right: 8px;
      background: #eaeaea;
      border-radius: 62px;
      border: none;
      outline: none;
      // padding: 0 12px;
      width: 108px;
      z-index: 5;
    }
  }
  .checkbox {
    margin-bottom: 48px;
  }
  /deep/ .ivu-form-item-error-tip {
    left: 20px;
    font-size: 14px;
  }
}

.main-left {
  width: 60%;
}
.main-right {
  width: 30%;
}
.middle-line {
  height: 600px;
  width: 1px;
  background: #d5d5d5;
  margin-left: 50px;
}
.title {
  margin-bottom: 50px;
  font-weight: normal;
  font-family: PingFangSC-Regular;
  font-size: 24px;
  color: #333333;
  text-align: center;
}
.content-wrapper {
  // height: 420px;
  // overflow: auto;
  // margin-right: -17px;
}
.content-container {
  width: 100%;
  overflow: hidden;
  position: relative;
}
.content {
  padding: 0 30px;
  p {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #666666;
    line-height: 26px;
  }
}
.mb30 {
  margin-bottom: 20px;
}
.btn {
  text-align: center;
  display: inline-block;
  background: #ff7d41;
  width: 120px;
  height: 38px;
  line-height: 38px;
  color: #fff;
  border-radius: 19px;
  transition: background-color 0.2s linear;
  &:hover {
    background-color: #e57e63;
  }
}
.btn-auth {
  width: 100%;
}
#track {
  position: absolute;
  height: 100%;
  width: 10px;
  background: #e7e7e7;
  border-radius: 100px;
  top: 0;
  right: 0;
}
#scrollBar {
  background: hsl(0, 0%, 60%);
  border-radius: 100px;
  position: absolute;
  height: 110px;
  width: 4px;
  left: 3px;
  top: 0;
  cursor: pointer;
}
.checkbox {
  /deep/ .ivu-checkbox-wrapper {
    margin-right: 0;
  }
  /deep/ .ivu-checkbox-inner {
    width: 18px;
    height: 18px;
    &::after {
      width: 6px;
      height: 10px;
      top: 1px;
      left: 5px;
    }
  }
  .agree {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #333333;
    margin-left: 3px;
    margin-right: 0;
  }
  .query {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    // color: #df5e3c;
  }
}
.query-protocols-header {
  padding: 0.25rem 0.3rem;
  .logo {
    height: 100%;
    width: auto;
    cursor: pointer;
  }
  .close {
    cursor: pointer;
  }
}

.imgCode {
  display: inline-block;
  height: 46px;
  width: 30%;
  vertical-align: middle;
}
.btn-refresh {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  cursor: pointer;
}
.img-auth {
  /deep/ .ivu-input-wrapper {
    width: 55%;
    margin-right: 10px;
  }
}
.query-wapper {
  width: 9rem;
  margin: 0 auto;
}
.query-title {
  margin-top: 1.2rem;
  margin-bottom: 1rem;
  font-weight: normal;
  font-family: PingFangSC-Regular;
  font-size: 0.38rem;
  color: #333333;
  text-align: center;
}

.form-group {
  background: #ffffff;
  border: 1px solid #313131;
  border-radius: 52px;
  padding: 0.2rem 0;
  /deep/ .ivu-form-item-error-tip {
    font-size: 14px;
    top: 0.7rem;
    color: #ef4747;
    left: 10px;
  }
}
.select-wrapper {
  padding-left: 0.4rem;
  padding-right: 0.3rem;
  width: 2.1rem;
  position: relative;
  /deep/ .ivu-input-wrapper {
    .ivu-input {
      cursor: pointer;
      background: #ffffff;
    }
  }
  /deep/ .ivu-icon {
    position: absolute;
    right: 0.3rem;
    top: 50%;
    transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    font-size: 18px;
  }
}
.form-query {
  /deep/ .ivu-input {
    border: none;
    font-family: PingFangSC-Regular;
    font-size: 0.24rem;
    color: #000000;
    // padding:0;
  }
}
.form-group {
  // display: -webkit-box;
  // display: -webkit-flex;
  // display: -ms-flexbox;
  // display: flex;
  // align-items: center;
  // display: table;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  .name {
    width: 2.65rem;
    /deep/ .ivu-input {
      padding-left: 0.28rem;
    }
  }
  .idcard {
    width: 3.5rem;
    /deep/ .ivu-input {
      padding-left: 0.28rem;
    }
  }
  .bar {
    width: 1px;
    height: 0.4rem;
    background-color: #313131;
  }
  .btn-search {
    position: absolute;
    width: 0.46rem;
    right: 0.25rem;
    cursor: pointer;
  }
}
.query-type-list-wrapper {
  position: absolute;
  background: #ffffff;
  border: 1px solid #999999;
  border-radius: 3px;
  width: 1.5rem;
  padding: 0.3rem 0;
  z-index: 10;

  li {
    text-align: center;
    height: 0.45rem;
    line-height: 0.45rem;
    font-family: PingFangSC-Regular;
    font-size: 0.2rem;
    color: #333333;
    cursor: pointer;
    &:hover {
      background: #f2f2f2;
    }
  }
}
.sleceted {
  background: #f2f2f2;
}
.error-tips {
  position: absolute;
  top: 100%;
  left: 20px;
  line-height: 1;
  padding-top: 6px;
  font-size: 14px;
  color: #ef4747;
  white-space: nowrap;
  z-index: 10;
  background-color: #f5f5f5;
}
.search-tips {
  // width: 5.8rem;
  margin: 0 auto;
  font-family: PingFangSC-Regular;
  font-size: 0.2rem;
  color: #666666;
  letter-spacing: 0;
  position: relative;
  margin-top: 0.6rem;
  // padding-left: 0.8rem;
  text-align: center;
}
.icon-tips {
  vertical-align: top;
  width: 0.4rem;
  height: 0.4rem;
  // margin-right: 20px;
}
.f-line {
  display: inline-block;
  span {
    padding-left: 20px;
  }
}
.query-tips {
  font-size: 14px;
  text-align: center;
  margin-top: 30px;
  color: #999;
  .ivu-icon {
    color: #999;
    margin-right: 5px;
  }
}
.mask {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 20;
  background: transparent;
}
.placeholder {
  position: absolute;
  z-index: 1;
  padding-left: 0.28rem;
  font-size: 0.24rem;
  color: #999;
  cursor: text;
}
.placeholder-auth {
  padding-left: 20px;
  font-size: 14px;
  line-height: 46px;
  height: 46px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/DiscreditInquiry.vue